import React, { ReactElement } from 'react';

function Separator(): ReactElement {
  return <div style={{ borderTop: '1px solid rgba(0, 0, 0, .5)' }} />;
}

export default Separator;
